import ArtFromFollowed from './ArtFromFollowed';

export default ArtFromFollowed;
